// extracted by mini-css-extract-plugin
export var box = "codeSnippet-module--box--c4a54";
export var center = "codeSnippet-module--center--638bc";
export var newsletter = "codeSnippet-module--newsletter--45cb9";